var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PySparkJob_1;
import { JsonSchema, JSON, JsonConverter, DateConverter } from '@symon-ai/wisepipe-serialize';
import { Job } from './job';
export var PySparkJobState;
(function (PySparkJobState) {
    PySparkJobState["PENDING"] = "pending";
    PySparkJobState["SUBMITTED"] = "submitted";
    PySparkJobState["RUNNING"] = "running";
    PySparkJobState["COMPLETED"] = "completed";
    PySparkJobState["FAILED"] = "failed";
    PySparkJobState["CANCEL_PENDING"] = "cancel_pending";
    PySparkJobState["CANCELLED"] = "canceled";
})(PySparkJobState || (PySparkJobState = {}));
const schema = {
    $id: 'urn:wisepipe-python-job-domain:PySparkJob',
    type: 'object',
    properties: {
        state: { type: 'string', enum: Object.values(PySparkJobState) },
        pySparkStart: { type: 'string', format: 'date-time' }
    },
    required: ['state']
};
let PySparkJob = PySparkJob_1 = class PySparkJob extends Job {
    constructor(id, state, start, pySparkStart) {
        super(id, start);
        this.state = state;
        if (pySparkStart !== undefined)
            this.pySparkStart = pySparkStart;
        JSON.validate(this, PySparkJob_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], PySparkJob.prototype, "pySparkStart", void 0);
PySparkJob = PySparkJob_1 = __decorate([
    JsonSchema(schema)
], PySparkJob);
export { PySparkJob };
//# sourceMappingURL=pySparkJob.js.map